import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

/**
 * List configured MyPay API environments for onboarding workflow routing.
 * Wraps `api.listMyPayEnvironments`; see `useCompanyConfigs` for the pattern.
 */
export function useMyPayEnvironments() {
  return useQuery({
    queryKey: ["mypayEnvironments"],
    queryFn: () => api.listMyPayEnvironments(),
  });
}
